import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div>
      <h4>404 Not Found</h4>
      <Link to="/">
        <button className="btn btn-danger">Go Back</button>
      </Link>
    </div>
  );
};

export default NotFound;
